(function () {
  var SECTION_SELECTOR = '.clare-section-hero';
  var VIDEO_SELECTOR = '[data-clare-hero-video]';
  var READY_CLASS = 'is-ready';

  var sectionState = new Map();

  // A hero video is decorative. Skip it entirely when the visitor has asked for
  // less motion, or when the connection says data is expensive.
  function shouldSkip(video) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;

    var conn = navigator.connection;
    if (conn) {
      if (conn.saveData) return true;
      if (/(^|-)2g$/.test(conn.effectiveType || '')) return true;
    }

    if (video.getAttribute('data-desktop-only') === 'true') {
      if (!window.matchMedia('(min-width: 750px)').matches) return true;
    }

    return false;
  }

  // Pick one source set for the current viewport, falling back to the other
  // when only one video is configured. Only the chosen set is ever promoted to
  // a real src, so exactly one file downloads.
  function selectSources(video) {
    var isMobile = !window.matchMedia('(min-width: 750px)').matches;
    var preferred = isMobile ? 'mobile' : 'desktop';
    var fallback = isMobile ? 'desktop' : 'mobile';

    var chosen = video.querySelectorAll('source[data-media="' + preferred + '"][data-src]');
    if (!chosen.length) {
      chosen = video.querySelectorAll('source[data-media="' + fallback + '"][data-src]');
    }
    return chosen;
  }

  // Sources are parked in data-src so nothing is fetched during the critical
  // path — not by the preload scanner, not by the media element itself.
  function attachSources(video) {
    var sources = selectSources(video);
    if (!sources.length) return false;

    // Drop the set we did not choose so the browser cannot consider it.
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      if (Array.prototype.indexOf.call(sources, source) === -1) {
        source.parentNode.removeChild(source);
      }
    });

    sources.forEach(function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });
    return true;
  }

  function start(video, signal) {
    if (signal.aborted) return;
    if (shouldSkip(video)) return;
    if (!attachSources(video)) return;

    video.addEventListener(
      'canplaythrough',
      function () {
        if (signal.aborted) return;

        var played = video.play();
        if (played && typeof played.catch === 'function') {
          // Autoplay refused: leave the poster image in place.
          played.catch(function () {});
        }
        video.classList.add(READY_CLASS);
      },
      { once: true, signal: signal }
    );

    video.addEventListener(
      'error',
      function () {
        video.classList.remove(READY_CLASS);
      },
      { once: true, signal: signal }
    );

    video.load();
  }

  // Wait for load, then for the main thread to go idle, so the video never
  // competes with the hero image for bandwidth or decode time.
  function scheduleAfterLoad(fn) {
    var run = function () {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(fn, { timeout: 3000 });
      } else {
        window.setTimeout(fn, 400);
      }
    };

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function initSection(section) {
    var video = section.querySelector(VIDEO_SELECTOR);
    if (!video) return;

    destroySection(section);

    var controller = new AbortController();
    sectionState.set(section, controller);

    scheduleAfterLoad(function () {
      start(video, controller.signal);
    });
  }

  function destroySection(section) {
    var controller = sectionState.get(section);
    if (!controller) return;
    controller.abort();
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
